// /users/:id — карточка пользователя в боковой панели справа.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { UserCard } from '../../../features/users/UserCard.tsx';

export const Route = createFileRoute('/_app/_settings/users/$id')({
  component: UserCardRoute,
});

function UserCardRoute() {
  const { id } = Route.useParams();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <UserCard
      key={id}
      id={id}
      onClose={() => void navigate({ to: '/users', search: (prev) => prev })}
    />
  );
}
